import { Skeleton } from '@/components/ui/skeleton'

interface Props {
  withMultiSelection?: boolean
}

export const NewMessageUsersListItemSkeleton = ({
  withMultiSelection,
}: Props) => {
  return (
    <div className="flex w-full flex-col px-3 py-4 pb-0">
      <div className="flex flex-1 items-center gap-3 pb-4">
        {withMultiSelection && (
          <div className="h-4 w-4 rounded-full border border-secondary-100" />
        )}
        <Skeleton className="h-[50px] w-[50px] rounded-full dark:bg-skeleton" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-full max-w-[200px] dark:bg-skeleton" />
          <Skeleton className="h-4 w-[130px] dark:bg-skeleton" />
        </div>
      </div>
      <div className="ml-[62px] border-b" />
    </div>
  )
}
